export default __webpack_public_path__ + "static/media/voting-2.5bc92c4d.jpg";